import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

interface ItemButtonTypes {
  onClick?(...args: unknown[]): unknown;

  buttonClass?: string;
  icon?: IconProp;
}

function ItemButton({ onClick, buttonClass, icon }: ItemButtonTypes) {
  return (
    <button onClick={onClick} className={`btn btn-sm ${buttonClass}`}>
      {icon && <FontAwesomeIcon icon={icon} />}
    </button>
  );
}

export default ItemButton;
